export const dataFaqIT = [
  {
    question: "A cosa serve questa pagina?",
    answer: "Su questa pagina è possibile segnalare problemi tramite il pulsante APRI TICKET, richiedendo così il supporto di uno dei nostri sviluppatori. Se una certa richiesta diventa molto frequente, allora la inseriremo in questa lista di FAQ (Frequently Asked Questions), così che diventi sempre più semplice per l'utente orientarsi fra le pagine di questo applicativo.",
  },
  {
    question: "Quando aprire un ticket?",
    answer: "È importante che il team di sviluppo di Genius Lab venga allertato in caso di comportamenti errati dell'applicazione, mancanza di dati ed incongruenze.",
  },
  {
    question: "Come faccio a sapere quando la mia segnalazione verrà risolta?",
    answer: "Quando il problema sarà risolto riceverai una mail automatica da parte del team di Ammagamma.",
  },
  {
    question: "Ho una proposta di miglioramento: a chi devo segnalarla?",
    answer: "I ticket sono dedicati esclusivamente alla segnalazione di malfunzionamenti. Tutte le proposte di miglioramento, richieste di nuove funzionalità e suggerimenti per la crescita di Genius Lab devono essere indirizzate al team di riferimento in Kerakoll.",
  }
];


export const dataFaqEN = [
  {
    question: "What is this page for?",
    answer: "Use this page to report problems via the OPEN TICKET button, thus requesting the support of one of our developers. If a certain request becomes very frequent, then we will insert it in this FAQ (Frequently Asked Questions) list, so that it becomes easier for the user to find his way around the pages of this application.",
  }
];


export const dataFaqES = [
  {
    question: "¿Para qué es esta página?",
    answer: "En esta página puede reportar problemas usando el botón ABRIR TICKET, solicitando así el apoyo de uno de nuestros desarrolladores. Si una determinada solicitud se vuelve muy frecuente, la insertaremos en esta lista de preguntas frecuentes (FAQ, por sus siglas en inglés), para que al usuario le resulte cada vez más fácil navegar por las páginas de esta aplicación.",
  }
];

